import { useTranslation, UseTranslationOptions } from "react-i18next";

const TRANSLATION_SUFFIX = ".translation";

const isTranslationKey = (value: unknown): value is string =>
  typeof value === "string" && value.endsWith(TRANSLATION_SUFFIX);

const useConditionalTranslation = <T>(
  keyOrText: T,
  ns?: string,
  options?: UseTranslationOptions<string>,
): T => {
  const { t } = useTranslation(ns, options);
  const translateIfNeeded = (value: unknown) =>
    isTranslationKey(value) ? t(value, { defaultValue: value }) : value;

  if (Array.isArray(keyOrText)) {
    return keyOrText.map(translateIfNeeded) as T;
  }
  return translateIfNeeded(keyOrText) as T;
};

export default useConditionalTranslation;
